import logo from './logo.svg';
import './App.css';
import Form from './components/Form/Form.jsx'

function App() {
  return (
    <div className="App">
      <Form />
    </div>
  );
}

export default App;
